import LoaderOverlay from "@/components/modules/LoaderOverlay.vue";
import ErrorOverlay from "@/components/modules/ErrorOverlay.vue";
import SuccessOverlay from "@/components/modules/SuccessOverlay.vue";


export default {
  install: (app) => {
    // Globale Komponenten registrieren
    app.component('LoaderOverlay', LoaderOverlay);
    app.component('ErrorOverlay', ErrorOverlay);
    app.component('SuccessOverlay', SuccessOverlay);
  }
}
